import React, { useState } from "react";
import UseContext from "hooks/useContext";
import useModal from "../../../useModal";
import Modalheader from "../../../components/header";
import ModalBody from "../../../components/body";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";
import ApiDatabase from "server";
import { toast } from "react-toastify";
import { formatChangeValue, getFieldLabel } from "utils/amendmentFormat";

const ModalAmendmentResponse = () => {
  const { toggle } = useModal();
  const {
    amendmentRequestData,
    amendmentAction,
    setRefreshContract,
    refreshContract,
  } = UseContext();
  const [isLoading, setIsLoading] = useState(false);

  const isAccept = amendmentAction === "accept";

  const handleConfirm = () => {
    if (!amendmentRequestData?._id) return;
    setIsLoading(true);
    ApiDatabase.respondAmendment(
      {
        idRequest: amendmentRequestData._id,
        response: isAccept ? "accepted" : "refused",
      },
      (data) => {
        toast.success(data.success || data.message);
        setRefreshContract(!refreshContract);
        toggle();
      },
      (err) => {
        toast.error(err.response?.data?.message || "Erreur");
        setIsLoading(false);
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Confirmer votre réponse
      </Modalheader>
      <ModalBody>
        <div className="text-sm text-gray-500 flex flex-col gap-3">
          {amendmentRequestData?.changes?.map((change, idx) => (
            <div
              key={idx}
              className="bg-gray-100 px-2 py-4 rounded flex flex-col gap-1"
            >
              <span className="font-medium text-gray-700">
                {getFieldLabel(change.field)}
              </span>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="line-through text-gray-400">
                  {formatChangeValue(change.field, change.before)}
                </span>
                <span className="text-gray-400">→</span>
                <span className="text-gray-800">
                  {formatChangeValue(change.field, change.after)}
                </span>
              </div>
            </div>
          ))}
          <div className="mt-2">
            {isAccept
              ? "En acceptant, un avenant de prolongation sera généré."
              : "En refusant, la mission restera inchangée."}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        {isLoading ? (
          <>
            <Button size="LG" color="DISABLED">
              Annuler
            </Button>
            <Button size="LG" color="DISABLED">
              Traitement ...
            </Button>
          </>
        ) : (
          <>
            <Button size="LG" color="SECONDARY" onClick={toggle}>
              Annuler
            </Button>
            <Button
              size="LG"
              color={isAccept ? "PRIMARY" : "DANGER"}
              onClick={handleConfirm}
            >
              Confirmer
            </Button>
          </>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalAmendmentResponse;
